export default __webpack_public_path__ + "static/media/usergroup-delete.670d12c3.svg";